import * as React from "react";

import { empty } from "../../../services/api/requestState";
import * as m from "../../model/model";
import { noop } from "../../utils/noop";

import type { RequestState } from "../../../services/api/requestState";

import BokioPlan = m.Entities.BokioPlan;

type PlanInfoDto = m.Bokio.Common.Contract.ViewData.PlanInfoDto;

export type PricePlanContextValue = {
	plan: BokioPlan | undefined;
	planInfo: PlanInfoDto | undefined;
	plannedChange: m.Day | undefined;
	nextPlan: BokioPlan | undefined;
	inTrial: boolean;
	hasPurchasedPlan: boolean;
	daysUntilTrialEnded: number | undefined;
	planName: string;
	nextPlanName: string | undefined;
	canPurchase: boolean;
	request: RequestState<m.Envelope<m.Bokio.Common.Contract.ViewData.BokioPlanDto, m.SimpleError>>;
	refresh: () => Promise<void>;
};

export const PricePlanContext = React.createContext<PricePlanContextValue>({
	plan: undefined,
	planInfo: undefined,
	plannedChange: undefined,
	nextPlan: undefined,
	inTrial: false,
	hasPurchasedPlan: false,
	daysUntilTrialEnded: undefined,
	planName: "Free",
	nextPlanName: undefined,
	canPurchase: false,
	request: empty(),
	refresh: noop,
});

export const usePricePlanContext = () => React.use(PricePlanContext);
